import React from 'react';
import {Card, Header} from 'semantic-ui-react';
import {createContent} from '../../utils';
import {downloadFile} from '../../../common/util/file';
import PdfIcon from '../icons/PdfIcon';
import TxtIcon from '../icons/TxtIcon';
import XMLIcon from '../icons/XMLIcon';
import CombosIcon from '../icons/CombosIcon';

const REP_SRI_FILES_URL = process.env.REP_SRI_FILES_URL;

function handleDowloadDocument(url, addMessageBoxError) {
  if (url && url !== '') {
    downloadFile(url);
    return null;
  }
  addMessageBoxError('Error, No se ha generado el documento');
}

function downloadTxtFile({
  invoice,
  showCombo,
  invoicesItem,
  invoicesCombos,
  addMessageBoxError,
}) {
  const {physicalNumber, clientAgency} = invoice;
  const content = createContent({
    invoice,
    invoicesItem,
    invoicesCombos,
    showCombo,
  });
  if (content != null) {
    const element = document.createElement('a');
    const file = new Blob([content], {'type': 'text/plain'});
    element.href = URL.createObjectURL(file);
    element.download = `F${clientAgency}${physicalNumber}.txt`;
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  } else {
    addMessageBoxError(
      'Error, faltan datos para generar el documento'
    );
  }
}

const IconsHeader = ({
  invoice,
  showCombo,
  invoicesItem,
  invoicesCombos,
  addMessageBoxError,
}) => {
  const {physicalNumber, serial, typeDocument, pdf, xml} = invoice;
  const pathDocument = typeDocument === 'FC' ? 'Facturas' : 'NotasCredito';
  const removeSpecialCharacter = serial.replace('-', '');
  const parseSerial = `${removeSpecialCharacter.slice(
    0,
    3
  )}-${removeSpecialCharacter.slice(3, 6)}`;
  const url = `${REP_SRI_FILES_URL}/${pathDocument}/${parseSerial}-${physicalNumber}`;
  const pdfUrl = pdf && pdf !== '' ? `${url}.pdf` : null;
  const xmlUrl = xml && xml !== '' ? `${url}.xml` : null;

  return (
    <div className='field-invoices-icons'>
      <div
        className='pointer'
        onClick={() => handleDowloadDocument(pdfUrl, addMessageBoxError)}
      >
        <PdfIcon />
      </div>
      <div
        className='pointer'
        onClick={() => handleDowloadDocument(xmlUrl, addMessageBoxError)}
      >
        <XMLIcon />
      </div>
      <div
        className='pointer'
        onClick={() =>
          downloadTxtFile({
            invoice,
            showCombo,
            invoicesItem,
            invoicesCombos,
            addMessageBoxError,
          })
        }
      >
        {showCombo ? <CombosIcon /> : <TxtIcon />}
      </div>
    </div>
  );
};

const FilesInvoiceHeader = ({
  show,
  invoice,
  showCombo,
  invoicesItem,
  invoicesCombos,
  addMessageBoxError,
}) => {
  return (
    <Card raised fluid>
      <div className='file-invoices-padding field-invoices-header'>
        <Header as='h2'>Facturación Electrónica</Header>
        {show && (
          <IconsHeader
            invoice={invoice}
            showCombo={showCombo}
            invoicesItem={invoicesItem}
            invoicesCombos={invoicesCombos}
            addMessageBoxError={addMessageBoxError}
          />
        )}
      </div>
    </Card>
  );
};

export default FilesInvoiceHeader;
